import { trace } from 'rytm-helpers';
import { updateLinks } from './linksFix';
import { warNumberedLists } from './../kom/war-numbered-lists';

const onCollapseShow = (e) => {
  const trigger = getCollapseTrigger(e.target.id);
  if (trigger.dataset.labelCollapse) {
    trigger.innerHTML = trigger.dataset.labelCollapse;
  }
  if (trigger.dataset.htmlClassName) {
    document.documentElement.classList.add(trigger.dataset.htmlClassName);
  }
}
const onCollapseHide = (e) => {
  const trigger = getCollapseTrigger(e.target.id);
  if (trigger.dataset.labelExpand) {
    trigger.innerHTML = trigger.dataset.labelExpand;
  }
  if (trigger.dataset.htmlClassName) {
    document.documentElement.classList.remove(trigger.dataset.htmlClassName);
  }
}
const getCollapseTrigger = (id) => {
  let trigger;
  if (id) {
    trigger = document.querySelector("a[href='#" + id + "']") || document.querySelector("[data-bs-target='#" + id + "']");
  }
  return trigger;
}

// ### Window update
export const windowUpdate = (e) => {
  updateLinks();
  warNumberedLists();
};
export const removeReCaptchaBadge = () => {
  const list = [...document.querySelectorAll(".grecaptcha-badge")];
  list.forEach((el) => {
    const parentDiv = el.parentNode;
    parentDiv.removeChild(el);
    // remove DIV
    parentDiv.parentNode.removeChild(parentDiv);
  })
}

// ### INIT
export const initCommon = () => {
  document.documentElement.addEventListener("show.bs.collapse", onCollapseShow);
  document.documentElement.addEventListener("hide.bs.collapse", onCollapseHide);
  window.addEventListener('resize', windowUpdate);
  document.addEventListener('DOMContentLoaded', windowUpdate);
  // window update
  windowUpdate();
};

